import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { TablaPlantas } from "../Components/Tablas";
import { useSelector } from "react-redux";
import { BtnVolverDinamico } from "../Components/Botones";
import { ModalDinamico } from "../Components/Modals";
import { FormAddPlanta } from "../Components/Forms_Add";
import { useNavigate, useParams } from "react-router-dom";
import { NotFound } from "../Pages/NotFound";
import { filterData, findName } from "../globalFunctions";

export const Plantas = () => {
  const dataPlantas = useSelector((state) => state.Plantas.data);
  const dataEmpresas = useSelector((state) => state.Empresas.data);
  const { idEm } = useParams();
  const [valueSearch, setValueSearch] = useState("");
  const [dataInit, setDataInit] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const plByEm = filterData(dataPlantas, "em_iden", parseInt(idEm));
    valueSearch === ""
      ? setDataInit(plByEm)
      : setDataInit(filterData(plByEm, "pl_desc", valueSearch));
  }, [valueSearch, dataPlantas, idEm]);

  return (
    <Container style={{ maxWidth: "900px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          marginTop:"5px"
        }}
      >
        <div>
          <BtnVolverDinamico
            click={() => {
              navigate("/Empresas");
            }}
          />
        </div>
        <div style={{ textAlign: "center" }}>
          <div
            style={{ fontStyle: "italic", textAlign: "center", padding: "5px" }}
          >
            <span>Plantas de la Empresa:</span>
            <b style={{ display: "block", color: "#46be6a" }}>
              {findName(dataEmpresas, "em_iden", parseInt(idEm), "em_name")}
            </b>
          </div>

          <ModalDinamico
            size={"sm"}
            variant={"outline-dark"}
            Body={<FormAddPlanta idEmp={idEm} />}
            Titulo="Agregar Planta"
            nameBoton="Agregar Planta"
          />
        </div>
      </div>

      <hr />

      <div
        style={{
          textAlign: "center",
        }}
      >
        <span style={{ fontStyle: "italic" }}>Buscar </span>
        <input
          type="text"
          placeholder="Nombre Planta"
          onChange={(e) => {
            setValueSearch(e.target.value);
          }}
        />
      </div>

      <div>
        {dataInit.length === 0 ? (
          <NotFound textoImagen={"Ninguna Planta Registrada"} />
        ) : (
          <TablaPlantas data={dataInit} />
        )}
      </div>
    </Container>
  );
};
